class EmailSignup extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      button: '[js-email-button]'
    }
  }

  connectedCallback() {
    this.button = this.querySelector(this.selectors.button);
    this._setEventListeners();
  }

  _setEventListeners = () => {
    enquire.register(config.mediaQueries['desktop'],{
      match: function(){
        this.button.addEventListener('click', this._displayModalDesktop);
        this.button.removeEventListener('click', this._displayModalMobile);
      }.bind(this)
    })
  
    enquire.register(config.mediaQueries['belowDesktop'],{
      match: function(){
        this.button.removeEventListener('click', this._displayModalDesktop);
        this.button.addEventListener('click', this._displayModalMobile);
      }.bind(this)
    })
  }

  _displayModalDesktop = (evt) => {
    var desktopId = this.button.dataset.desktop;
    window.__attentive.trigger(null,null,null,desktopId)
  }

  _displayModalMobile = (evt) => {
    var mobileId = this.button.dataset.mobile;
    window.__attentive.trigger(null,null,null,mobileId)
  }
}

customElements.define("email-signup", EmailSignup);